import Home from '../pages/Home.vue';
import { pages } from '../seo/pages.mjs';

const components = {
  Home,
  Downloads: () => import(/* webpackChunkName: "downloads" */ '../pages/Downloads.vue'),
  Docs: () => import(/* webpackChunkName: "docs" */ '../pages/Docs.vue'),
  Review: () => import(/* webpackChunkName: "modeck-review" */ '../pages/Review.vue'),
  'Privacy Policy': () => import(/* webpackChunkName: "privacy-policy" */ '../pages/PrivacyPolicy.vue'),
  'Terms And Conditions': () => import(/* webpackChunkName: "terms-and-conditions" */ '../pages/TermsAndConditions.vue'),
};

export const routes = [
  ...pages.map(page => ({ path: page.path, name: page.name, component: components[page.name], meta: { title: page.title } })),
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import(/* webpackChunkName: "not-found" */ '../pages/NotFound.vue') },
];
